import { createStyles } from 'antd-style'

interface Props {
  organizationColor: string
  backgroundColor: string
  cursor: React.CSSProperties['cursor']
}

export const useStyle = createStyles(
  ({ token }, { backgroundColor, organizationColor, cursor }: Props) => ({
    applicationItem: {
      height: 230,
      transition: 'all .2s linear',
      backgroundColor,

      '.ant-card-head': {
        borderBottom: 0
      },
      '.ant-card-body': {
        width: '100%'
      },

      '&[aria-disabled=false]:hover': {
        backgroundColor: organizationColor,
        color: token.colorWhite,
        boxShadow: `0 8px 16px 0 ${organizationColor}`,
        border: `1px solid ${organizationColor}`,

        '.ant-typography': {
          color: token.colorWhite,
          transition: 'all .2s linear'
        },

        '.ant-btn-icon svg': {
          color: token.colorWhite,
          transition: 'all .2s linear'
        },
        '.ant-avatar': {
          backgroundColor: token.colorWhite,
          color: organizationColor
        }
      }
    },

    avatar: {
      backgroundColor: organizationColor,
      marginBottom: '10px'
    },

    cursor: {
      cursor
    }
  })
)
